<div *ngIf="maxLength" class="d-flex justify-content-end">
  <div
    [ngClass]="isFieldInvalid ? 'text-danger' : 'text-secondary'"
    [attr.data-test-id]="'max-length-counter-' + dataTestId"
  >
    {{ valueLength }}/{{ maxLength }}
  </div>
</div>
